import http from '../../libs/http'
import router from '../../router'
import miniToastr from 'mini-toastr'

import {minitstr_config} from '@/constants';

export default {
    state: {
        loading: true,
    },
    mutations: {
    },
    actions: {
        async getCompanyProjects({commit, state}, options) {
            let sort_by = options.sort_by ? options.sort_by : 'updated_at';
            let sort_type = options.sort_type ? options.sort_type : 'desc';
            let limit = options.limit ? options.limit : 10;
            let page = options.page ? options.page : 1;

            if (options.company) {
				let data = http.route('project?filters[company_id]=' + options.company + '&page='+ page +'&sort_by='+ sort_by+ '&sort_order='+ sort_type+ '&limit='+limit).get();
				return data.then(res => {
						return res.data;
				});
            } else {
                return [];
            }
		}
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/company.js